import { useContext } from "react";
import './scroll-text.scss';
import { ReactComponent as Arrow} from '../../Assets/Svg/arrow.svg';
import LanguageContext from "../../Contexts/Language";

type propsType = {
    scrollTop: number
}
const ScrollText = (props: propsType) =>{
    const {language} = useContext(LanguageContext);
    const word = language.scrollText;
    return(
        <div className={`scroll-text ${props.scrollTop !== 0 ? "moved" : ""}`}>
            <div className="scroll-text-inner" key={word}>
                <div className="scroll-arrow jumping-letter" style={{animationDelay: `0ms`}}>
                    <Arrow/>
                </div>
                {word?.split("").map((letter,key) => (
                    <p className="jumping-letter" key={key} style={{animationDelay: `${key * 50 + 50}ms`}}>{letter}</p>
                ))}
                <div className="scroll-arrow jumping-letter" style={{animationDelay: `${word.length * 50 + 50}ms`}}>
                    <Arrow/>
                </div>
            </div>
        </div>
    )
}
export default ScrollText;